// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq2 = /* #__PURE__ */ Data_Eq.eq(Data_UTCTime.eqUTCTime);
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var fullNameIsSymbol = {
    reflectSymbol: function () {
        return "fullName";
    }
};
var infoIsSymbol = {
    reflectSymbol: function () {
        return "info";
    }
};
var numPeopleIsSymbol = {
    reflectSymbol: function () {
        return "numPeople";
    }
};
var phoneIsSymbol = {
    reflectSymbol: function () {
        return "phone";
    }
};
var reservationDateIsSymbol = {
    reflectSymbol: function () {
        return "reservationDate";
    }
};
var restaurantSlugIsSymbol = {
    reflectSymbol: function () {
        return "restaurantSlug";
    }
};
var CreateTableReservationIsSymbol = {
    reflectSymbol: function () {
        return "CreateTableReservation";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var CreateTableReservation = function (x) {
    return x;
};
var toFillFormTypeCreateTable = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesCreateTableReserv = {};
var rPCMethodNameCreateTableR = {
    rpcMethodName: function (v) {
        return "CreateTableReservation";
    }
};
var newtypeCreateTableReserva = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCreateTableReserv = function (dictHasField) {
    return dictHasField;
};
var eqCreateTableReservation = {
    eq: function (x) {
        return function (y) {
            return x.email === y.email && x.fullName === y.fullName && x.info === y.info && x.numPeople === y.numPeople && x.phone === y.phone && eq2(x.reservationDate)(y.reservationDate) && x.restaurantSlug === y.restaurantSlug;
        };
    }
};
var genericCreateTableReservation = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCreateTableReservation = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCreateTableReservation)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(emailIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fullNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(infoIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(numPeopleIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(phoneIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(reservationDateIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(restaurantSlugIsSymbol)(Data_Show.showString))(Data_UTCTime.showUTCTime))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))))(CreateTableReservationIsSymbol))
};
var unscrambleDecodeCreateTableReservation = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCreateTableReservation)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(emailIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(fullNameIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(infoIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(numPeopleIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(reservationDateIsSymbol)(Data_UTCTime.unscrambleDecodeUTCTime)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantSlugIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeCreateTableReservation = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCreateTableReservation)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CreateTableReservationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(restaurantSlugIsSymbol)(encodeWithOptionsOther))(reservationDateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UTCTime.encodeUTCTime)))(phoneIsSymbol)(encodeWithOptionsOther))(numPeopleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))(infoIsSymbol)(encodeWithOptionsOther))(fullNameIsSymbol)(encodeWithOptionsOther))(emailIsSymbol)(encodeWithOptionsOther)))))
};
var decodeCreateTableReservation = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCreateTableReservation)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CreateTableReservationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(restaurantSlugIsSymbol)(decodeWithOptionsOther)())(reservationDateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UTCTime.decodeUTCTime))())(phoneIsSymbol)(decodeWithOptionsOther)())(numPeopleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())(infoIsSymbol)(decodeWithOptionsOther)())(fullNameIsSymbol)(decodeWithOptionsOther)())(emailIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    CreateTableReservation,
    genericCreateTableReservation,
    eqCreateTableReservation,
    showCreateTableReservation,
    rPCMethodNameCreateTableR,
    rPCSitesCreateTableReserv,
    encodeCreateTableReservation,
    decodeCreateTableReservation,
    unscrambleDecodeCreateTableReservation,
    toFillFormTypeCreateTable,
    hasFieldCreateTableReserv,
    newtypeCreateTableReserva
};
